"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeDead = exports.updateAll = exports.killAll = exports.kill = exports.moveToXY = exports.moveToIIJ = exports.create = exports.findByIdSafe = exports.findById = exports.getAll = exports.EDiveSlashEffect = void 0;
var entitiesUtils_sidecar_1 = require("@entities/entitiesUtils-sidecar");
var imports_1 = require("@lib/imports");
var common_1 = require("@main/common");
var common_sidecar_1 = require("@main/common-sidecar");
var diveTilemap_sidecar_1 = require("@dive/tilemap/diveTilemap-sidecar");
var sprites_sidecar_1 = require("@sprites/sprites-sidecar");
var spritesCrew_1 = require("@dive/spriteRecyclers/spritesCrew");
var EDiveSlashEffect;
(function (EDiveSlashEffect) {
    EDiveSlashEffect[EDiveSlashEffect["Default"] = -1] = "Default";
    EDiveSlashEffect[EDiveSlashEffect["Null"] = 0] = "Null";
    EDiveSlashEffect[EDiveSlashEffect["Slash"] = 1] = "Slash";
    EDiveSlashEffect[EDiveSlashEffect["FireExplosion"] = 2] = "FireExplosion";
    EDiveSlashEffect[EDiveSlashEffect["ArrowHit"] = 3] = "ArrowHit";
})(EDiveSlashEffect = exports.EDiveSlashEffect || (exports.EDiveSlashEffect = {}));
var objs = [];
function getAll() {
    return objs;
}
exports.getAll = getAll;
function findById(id) {
    return entitiesUtils_sidecar_1.entitiesUtils.findById(id, objs);
}
exports.findById = findById;
function findByIdSafe(id) {
    return entitiesUtils_sidecar_1.entitiesUtils.findByIdSafe(id, objs);
}
exports.findByIdSafe = findByIdSafe;
function create(type) {
    var id = 0;
    id = common_1.createId(id);
    var obj = {
        id: id,
        idLoaded: -1,
        isDead: false,
        eType: 'voy-misc',
        type: type,
        x: 0,
        y: 0,
        i: -1,
        j: -1,
        elapsedSeconds: 0,
        // isFlipped: false,
    };
    objs.push(obj);
    return obj;
}
exports.create = create;
function moveToIIJ(obj, iij) {
    obj.i = iij.i;
    obj.j = iij.j;
    var t = diveTilemap_sidecar_1.diveTilemap.getSafe(iij.i, iij.j);
    if (t) {
        // A bit of offset
        var usrnd = common_sidecar_1.common.getUnsyncedRando();
        var ox = usrnd.intSymmetric(5);
        var oy = usrnd.intSymmetric(5);
        moveToXY(obj, t.x + ox, t.y + oy);
    }
}
exports.moveToIIJ = moveToIIJ;
function moveToXY(obj, x, y) {
    obj.x = x;
    obj.y = y;
}
exports.moveToXY = moveToXY;
function kill(obj) {
    obj.isDead = true;
}
exports.kill = kill;
function killAll() {
    imports_1.l.forEach(objs, function (c) {
        kill(c);
    });
    removeDead();
}
exports.killAll = killAll;
function updateAll() {
    imports_1.l.forEach(objs, function (c) {
        update(c);
    });
}
exports.updateAll = updateAll;
// export function updateTickAll() {
//   l.forEach(objs, (c) => {
//     updateTick(c)
//   })
//   removeDead()
// }
// function updateTick(obj: IVoyageCrew) {
//   if (obj.isDead || obj.isDying) {
//     return
//   }
// }
function removeDead() {
    entitiesUtils_sidecar_1.entitiesUtils.removeDead(objs, function (c) { });
}
exports.removeDead = removeDead;
var slashEffectSprites = __spreadArray(__spreadArray(__spreadArray([], __read(sprites_sidecar_1.sprites.diveEffects50C40)), __read(sprites_sidecar_1.sprites.diveEffects51C41)), __read(sprites_sidecar_1.sprites.diveEffects52C42));
var fireExplosionEffectSprites = __spreadArray(__spreadArray(__spreadArray([], __read(sprites_sidecar_1.sprites.diveEffects61C49)), __read(sprites_sidecar_1.sprites.diveEffects62C50)), __read(sprites_sidecar_1.sprites.diveEffects63C51));
var arrowHitEffectSprites = __spreadArray(__spreadArray(__spreadArray([], __read(sprites_sidecar_1.sprites.diveEffects72C58)), __read(sprites_sidecar_1.sprites.diveEffects73C59)), __read(sprites_sidecar_1.sprites.diveEffects74C60));
function update(obj) {
    var ds = common_sidecar_1.common.getUpdateDeltaScaled();
    if (obj.isDead) {
        return;
    }
    if (obj.isDying) {
        kill(obj);
    }
    obj.elapsedSeconds += ds;
    var frameTime = 0.1;
    var frame = Math.floor(obj.elapsedSeconds / frameTime);
    var frames = slashEffectSprites;
    if (obj.type === EDiveSlashEffect.FireExplosion) {
        frames = fireExplosionEffectSprites;
    }
    if (obj.type === EDiveSlashEffect.ArrowHit) {
        frames = arrowHitEffectSprites;
    }
    if (frame >= frames.length) {
        kill(obj);
    }
    else {
        var img = spritesCrew_1.spritesCrew.getNext(obj.x, obj.y, frames[frame]);
        // img.scaleX = obj.isFlipped ? -img.scaleX : img.scaleX
    }
}
